module.exports = __webpack_public_path__ + "static/media/donation1.02be36ae.webp";